<span class="lookup-result-name" [innerHTML]="item.lookupName | highlight: highlight"> </span>
<span *ngIf="showStatus" class="lookup-result-status status-word" [ngClass]="getStatusCss(item.lookupStatus)">{{
  getStatusDisplay(item.lookupStatus)
}}</span>
<span class="lookup-result-info" [innerHTML]="item.lookupInfo | highlight: highlight"> </span>
